import React from "react";

// "E-mail bounced" badge — shown only while the recorded bounce still concerns the customer's current address.
export const isEmailBounced = (c) => !!(c && c.email_bounce && c.email && (c.email_bounce.address || "").toLowerCase() === c.email.trim().toLowerCase());

export function EmailBouncedBadge({ customer, testid = "email-bounced-badge", className = "" }) {
  if (!isEmailBounced(customer)) return null;
  const b = customer.email_bounce;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-red-300 bg-red-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-red-700 ${className}`}
      title={`${customer.email} bounced on ${(b.at || "").slice(0, 10)} — ${b.reason || "address rejected"}. Automatic e-mails are paused until the address is corrected.`}
      data-testid={testid}
    >
      ✕ e-mail bounced
    </span>
  );
}
